module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-swap-blue-40087a.svg";